import axios from "axios";
import { ENDPOINTS } from "./ENDPOINT.js";

export const RoomServices = {

    getAllRoom: async () => {
        try {
            const response = await axios.get(ENDPOINTS.ROOM_DETAILS);
            return response.data;
        } catch (error) {
            console.error("Error fetching rooms:", error);
            throw error;
        }
    },
    getAllByTable: async (table) => {
        try {
            const response = await axios.get(`${ENDPOINTS.GET_ALL_TABLE}?table=${table}`);
            return response.data;
        } catch (error) {
            console.error("Error fetching rooms:", error);
            throw error;    
        }
    },
        getAllRoomByDate: async (date) => {
        try {
            const response = await axios.post(`${ENDPOINTS.ROOM_BY_DATE}?date=${date}`);
            return response.data;
        } catch (error) {
            console.error("Error fetching rooms:", error);
            throw error;
        }
    },
    roomReIndex: async (data) => {
        try {
            const response = await axios.put(
                ENDPOINTS.REINDEX,
                data
            );

            return response.data;
        } catch (error) {
            console.error("Error updating room sort order:", error);
            throw error;
        }
    },
    getAllUploadedImages: async () => {
        try {
            const response = await axios.get(ENDPOINTS.UPLOADED_IMAGES);
            return response.data;
        } catch (error) {
            console.error("Error fetching uploaded images:", error);
            throw error;
        }
    },
    createRoom: async (data) => {
        try {
            const response = await axios.post(ENDPOINTS.ROOM_DETAILS, data);
            return response.data;
        } catch (error) {
            console.error("Error fetching rooms:", error);
            throw error; // important so caller can handle it
        }
    },
    editRoom: async (id, data) => {
        try {
            const response = await axios.put(`${ENDPOINTS.ROOM_DETAILS}/${id}`, data);
            return response.data;
        } catch (error) {
            console.error("Error fetching rooms:", error);
            throw error; // important so caller can handle it
        }
    },
    
    getRoomByPrice: async (from, to, room_id) => {
        try {
            const response = await axios.post(`${ENDPOINTS.ROOM_DETAILS}/price?from=${from}&to=${to}&room=${room_id}`);
            return response.data;
        } catch (error) {
            console.error("Error fetching rooms:", error);
            throw error; // important so caller can handle it
        }
    },
    getBulkRoomByPrice: async (from, to, room_id) => {
        try {
            const response = await axios.post(`${ENDPOINTS.ROOM_DETAILS}/bluk-price?from=${from}&to=${to}&room=${room_id}`);
            return response.data;
        } catch (error) {
            console.error("Error fetching rooms:", error);
            throw error; // important so caller can handle it
        }
    },

    checkoutRoom: async (id, data) => {
        try {
            const response = await axios.patch(`${ENDPOINTS.CHECKOUT_ROOM}/${id}`, data);
            return response.data;
        } catch (error) {
            console.error("Error fetching rooms:", error);
            throw error; // important so caller can handle it
        }
    },

    editServiceRequest: async (data) => {
        try {
            const response = await axios.patch(`${ENDPOINTS.SERVICE_REQUESTS}`, data);
            return response.data;
        } catch (error) {
            console.error("Error fetching rooms:", error);
            throw error; // important so caller can handle it
        }
    },
    deleteRoom: async (id) => {
        try {
            const response = await axios.delete(`${ENDPOINTS.ROOM_DETAILS}/${id}`);
            return response.data;
        } catch (error) {
            console.error("Error fetching rooms:", error);
            throw error; // important so caller can handle it
        }
    },

    updatePaymentStatus: async (br_id, bl_id, data) => {
        try {
            const response = await axios.patch(`${ENDPOINTS.SERVICE_REQUESTS}/status?table=service_requests&br_id=${br_id}&bl_id=${bl_id}`, data);
            return response.data;
        } catch (error) {
            console.error("Error creating amenity:", error);
            throw error;
        }
    },
    getOnlineOrdesr: async () => {
        try {
            const response = await axios.get(`${ENDPOINTS.GET_ONLINE_ORDER}`);
            return response.data;
        } catch (error) {
            console.error("Error creating amenity:", error);
            throw error;
        }
    },
};
